export default "__VITE_ASSET__DJqTNV7U__"